(function () {
  // Sale collection: hide the discount badge when the visible image is not an on-sale variant's image.
  // The data-pavone-sale-media attribute on product-block holds a pipe-separated list of the media
  // IDs of every on-sale variant (e.g. "|123|456|789"), so the badge shows for all discounted colours.
  function initSaleBadges() {
    document.querySelectorAll('product-block[data-pavone-sale-media]').forEach(function (block) {
      var saleMediaIds = (block.getAttribute('data-pavone-sale-media') || '').split('|');
      var badge = block.querySelector('.product-label--sale');
      if (!badge) return;

      function updateBadge() {
        var active = block.querySelector('.product-block__image--active');
        badge.hidden = !active || saleMediaIds.indexOf(active.getAttribute('data-media-id')) === -1;
      }

      updateBadge();

      var observer = new MutationObserver(updateBadge);
      block.querySelectorAll('[data-media-id]').forEach(function (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  // Translate the label of the 'go to top' button to the visitor's language.
  function translateScrollToTop() {
    var btn = document.getElementById('scroll-to-top');
    if (!btn) return;
    var labels = {
      nl: 'Naar boven',
      de: 'Nach oben',
      fr: 'Haut de page',
      es: 'Ir arriba',
      it: 'Torna su',
      da: 'Til toppen'
    };
    var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var label = labels[lang];
    if (label) {
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    }
  }

  function init() {
    initSaleBadges();
    translateScrollToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
